import { Serializable } from '@/models/core/serializable';
import { Student } from '@/models/student/student';
import { GEnum } from '@/constants/enum.defination';

export class SchoolGroupCompetencyRanking implements Serializable<SchoolGroupCompetencyRanking> {
  competencyID: number;
  competencyName: string;
  competencyType: GEnum.CompetencyType;
  ranking: SchoolGroupCompetencyRankingStudent[];
  growthRanking: SchoolGroupCompetencyRankingStudent[];

  deserialize(input: any): SchoolGroupCompetencyRanking {
    this.competencyID = input.competencyID;
    this.competencyName = input.competencyName;
    this.competencyType = input.competencyType;
    this.ranking = input.ranking.map((d: SchoolGroupCompetencyRankingStudent) => new SchoolGroupCompetencyRankingStudent().deserialize(d));
    this.growthRanking = input.growthRanking.map((d: SchoolGroupCompetencyRankingStudent) => new SchoolGroupCompetencyRankingStudent().deserialize(d));
    return this;
  }
}

export class SchoolGroupCompetencyRankingStudent implements Serializable<SchoolGroupCompetencyRankingStudent> {
  rank: number;
  studentID: number;
  studentName: string;
  gradeAndSchoolClassName: string;
  score: number;

  deserialize(input: any): SchoolGroupCompetencyRankingStudent {
    this.rank = input.rank;
    this.studentID = input.studentID;
    this.studentName = input.studentName;
    this.gradeAndSchoolClassName = input.gradeAndSchoolClassName;
    this.score = input.score;
    return this;
  }
}
